/**
 * VLSI Expert Pvt. Ltd. wordmark / monogram.
 * Outer frame keeps the logo’s rounded-square look at every size.
 */
const BrandLogo = ({
  size = 'md',
  className = '',
  showWordmark = false,
  alt = 'VLSI Expert',
}) => {
  const sizes = {
    sm: { box: 'h-10 w-10', radius: '0.65rem' },
    md: { box: 'h-14 w-14', radius: '0.85rem' },
    lg: { box: 'h-24 w-24', radius: '1.25rem' },
    xl: { box: 'h-32 w-32', radius: '1.5rem' },
    hero: { box: 'h-36 w-36 sm:h-40 sm:w-40', radius: '1.65rem' },
  };
  const { box, radius } = sizes[size] || sizes.md;

  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <div
        className={`brand-logo-frame ${box} shrink-0 overflow-hidden`}
        style={{
          borderRadius: radius,
          backgroundColor: '#ffffff',
          boxShadow: '0 1px 3px rgba(15, 23, 42, 0.12)',
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL || ''}/vlsi-expert-logo.jpg`}
          alt={alt}
          className="h-full w-full object-cover"
          style={{ borderRadius: radius }}
        />
      </div>
      {showWordmark ? (
        <div className="text-left min-w-0">
          <p className="font-bold theme-text-gradient leading-tight truncate">VLSI Expert</p>
          <p className="text-xs theme-text-secondary">Pvt. Ltd.</p>
        </div>
      ) : null}
    </div>
  );
};

export default BrandLogo;
